/* Ten Antennas — page scope.

   Dawn does not stamp the template or the page handle onto <body> — measured
   earlier when a whole pass of cart CSS written against `.template-cart`
   matched nothing at all. Every page-specific stylesheet on this site needs a
   hook, so one is set here from the URL: /pages/our-story becomes
   `ta-page-our-story` on <html>.

   Set on <html> rather than <body> so the class exists before the body renders
   and there is no flash of unstyled layout. */
(function () {
  if (window.__taPageScope) return;
  window.__taPageScope = true;

  var path = window.location.pathname.replace(/\/+$/, '');
  var match = path.match(/\/pages\/([a-z0-9-]+)/i);

  if (match) {
    document.documentElement.classList.add('ta-page-' + match[1].toLowerCase());
  }
})();
